import { j as o } from "./atoms-v218.js";
import { StyledFooter as l, SecondaryLink as p, LinksContainer as d, LinkWithoutUnderline as x, SecondaryText as f } from "./atoms-v2135.js";
import { Column as j } from "./atoms-v212.js";
import { Grid as h } from "./atoms-v216.js";
import { useBreakpoints as k } from "./atoms-v251.js";
import { forwardRef as i } from "react";
const s = i(({ children: r, className: e, id: t }, a) => {
  const { current: n } = k(), c = n === "max" || n === "xLarge" ? 1 : 0;
  return /* @__PURE__ */ o.jsx(h, { className: e, id: t, ref: a, children: /* @__PURE__ */ o.jsx(j, { large: 8, max: 14, medium: 8, offset: c, small: 4, xLarge: 14, children: /* @__PURE__ */ o.jsxs(l, { children: [
    /* @__PURE__ */ o.jsx(p, { href: "https://selfbook.com", children: "Selfbook" }),
    /* @__PURE__ */ o.jsx(d, { children: r })
  ] }) }) });
});
s.displayName = "Footer";
const m = i(({ children: r, ...e }, t) => /* @__PURE__ */ o.jsx(x, { ref: t, ...e, children: /* @__PURE__ */ o.jsx(f, { type: "helper", variant: "productive", children: r }) }));
m.displayName = "FooterLink";
const b = Object.assign(s, {
  Link: m
});
export {
  b as Footer
};
